import { gql } from '@apollo/client';

export const MODEL_VERSION = gql`
  query GetAvailableModelVersions(
    $inputEurotaxCode: String
    $inputBrandNames: [String!]
    $inputModelNames: [String!]
    $inputModelVersion: String
    $inputConstructorCode: String
    $inputPlateNumber: String
    $inputVehicleYears: [Int!]
  ) {
    getAvailableModelVersions(
      inputEurotaxCode: $inputEurotaxCode
      inputBrandNames: $inputBrandNames
      inputModelNames: $inputModelNames
      inputModelVersion: $inputModelVersion
      inputConstructorCode: $inputConstructorCode
      inputPlateNumber: $inputPlateNumber
      inputVehicleYears: $inputVehicleYears
    ) {
      identifiedVehicle {
        brandName
        modelName
        vehicleRegistrationDateISO8601
      }
      modelVersions {
        brandName
        eurotaxCode
        label
        marketingYears
      }
      vehicleIdentifierRemainingRequestsAmount
    }
  }
`;
